import React, { useState } from "react";
import image1 from "./redsrprojectimages/1000073067.jpg";
import image2 from "./redsrprojectimages/1000073079.jpg";
import image3 from "./redsrprojectimages/1000073081.jpg";
import image4 from "./redsrprojectimages/1000073088.jpg";
import image5 from "./redsrprojectimages/1000073094.jpg";
import image6 from "./redsrprojectimages/1000073108.jpg";
import image7 from "./redsrprojectimages/1000073110.jpg";
import image8 from "./redsrprojectimages/1000073112.jpg";
import image9 from "./redsrprojectimages/1000073136.jpg";
import image10 from "./redsrprojectimages/1000074032.jpg";
import image11 from "./redsrprojectimages/1000082862.jpg";
import image12 from "./redsrprojectimages/1000082870.jpg";
import image13 from "./redsrprojectimages/1000083158.jpg";
import image14 from "./redsrprojectimages/1000083185.jpg";
import image15 from "./dsrprojectimages/1000083380.jpg";
import image16 from "./dsrprojectimages/1000083394.jpg";
import image17 from "./dsrprojectimages/1000083396.jpg";
import image18 from "./dsrprojectimages/1000083407.jpg";
import image19 from "./dsrprojectimages/1000083431.jpg";
import image20 from "./dsrprojectimages/1000083487.jpg";
import image21 from "./dsrprojectimages/1000083519.jpg";
import image22 from "./dsrprojectimages/1000086745.jpg";
import image23 from "./dsrprojectimages/1000086747.jpg";
import image24 from "./dsrprojectimages/1000086749.jpg";
import image25 from "./dsrprojectimages/dsr_project_image.jpg";

import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import { Card, CardBody } from "reactstrap";

export const FieldActivities = ({subProjectData}) => {
  const [largeImage, setLargeImg] = useState(false);
  const [imageShow, setImageshow] = useState("");
//   console.log("subProjectData444",subProjectData)
  return (
      <div className="p-0">
        <div className="field-activities-container">
          <div className="image-grid">
           {subProjectData?.map((img, index) => (
  <div className="image-card" key={index}>
    {img.type?.includes("image")?
    <img
      src={img.url}
      alt={`Field ${index + 1}`}
      className="cursor-pointer"
      onClick={() => {
        setLargeImg(true);
        setImageshow(img.url);
      }}
    />
    :
     <video
            src={img.url || img.preview}
            width="100%"
            height="100%"
            controls
            className="rounded"
          />
    }
  </div>
))}
   {largeImage && (
              <Lightbox
                image={imageShow}
                title="Image Title"
                onClose={() => setLargeImg(false)}
              />
            )}
          </div>
          {subProjectData?.length===0&&  <div
              style={{
                textAlign: "center",
                padding: "50px 20px",
                color: "#666",
                fontSize: "18px",
                fontWeight: "500",
                background: "#fafafa",
                borderRadius: "8px",
                border: "1px dashed #ccc",
              }}
            >
              🚜 No activities found yet.  
              <p style={{ fontSize: "14px", marginTop: "8px", color: "#888" }}>
                Please check back later for updates.
              </p>
            </div>
        }
        </div>
            
      </div>
  );
};
